import { capitalizeFirstLetter } from '~domain/helper/formatters';
import { Translator } from '~domain/i18n';
import { HomeLine } from '~domain/model/core/home-line';
import { ProductType } from '~domain/model/core/product-type';

export const formatProductName = (translator: Translator, productType: ProductType, productLine?: HomeLine): string => {
  const { t } = translator;
  let formattedProductName = '';

  if (productType === ProductType.Car) {
    formattedProductName += capitalizeFirstLetter(t(`policies.productName.${ProductType.Car}`));
  } else if (productType === ProductType.Home) {
    formattedProductName += capitalizeFirstLetter(t(`policies.productName.${ProductType.Home}.${productLine}`));
  }

  return formattedProductName;
};
